import _ from 'lodash';
import Debug from 'debug';
import { List, Map, fromJS } from 'immutable';
import { createStore } from 'fluxible/addons';
import CustomerConstants from '../constants/CustomerConstants';
import Customer from '../models/Customer';
import { RequestStates } from './PaginatedStore';

const debug = Debug('delectable');

let CustomerStore = createStore({
  storeName: 'CustomerStore',
  handlers: {
    [CustomerConstants.AUTH_CUSTOMER_START]             : 'requestStart',
    [CustomerConstants.AUTH_CUSTOMER_SUCCESS]           : 'authSuccess',
    [CustomerConstants.AUTH_CUSTOMER_FAILURE]           : 'requestFailure',
    [CustomerConstants.DISMISS_COOKIES_START]           : 'dismissCookiesStart',
    [CustomerConstants.LOAD_DISMISS_COOKIES_START]      : 'loadDismissCookiesStart',
    [CustomerConstants.FETCH_CUSTOMER_START]            : 'requestStart',
    [CustomerConstants.FETCH_CUSTOMER_SUCCESS]          : 'fetchSuccess',
    [CustomerConstants.FETCH_CUSTOMER_FAILURE]          : 'requestFailure',
    [CustomerConstants.UPDATE_CUSTOMER_START]           : 'requestStart',
    [CustomerConstants.UPDATE_CUSTOMER_SUCCESS]         : 'updateSuccess',
    [CustomerConstants.UPDATE_CUSTOMER_FAILURE]         : 'updateFailure',
    [CustomerConstants.ADD_CUSTOMER_IDENTIFIER_START]   : 'requestStart',
    [CustomerConstants.ADD_CUSTOMER_IDENTIFIER_SUCCESS] : 'updateSuccess',
    [CustomerConstants.ADD_CUSTOMER_IDENTIFIER_FAILURE] : 'updateFailure',
    [CustomerConstants.RESET_CUSTOMER_PASSWORD_START]   : 'requestStart',
    [CustomerConstants.RESET_CUSTOMER_PASSWORD_SUCCESS] : 'requestSuccess',
    [CustomerConstants.RESET_CUSTOMER_PASSWORD_FAILURE] : 'requestFailure'
  },

  initialize() {
    this.currentCustomer = null;
    this.currentError = null;
    this.currentRequestStatus = null;
    this.dismissCookies = false;
  },

  logError(error) {
    if(typeof Bugsnag !== 'undefined' && error) {
      Bugsnag.notifyException(error, error.name || 'Error', {metadata: error.metadata} || {});
    }
  },

  loadDismissCookiesStart(payload) {
    if (payload.dismiss_cookies) {
      this.dismissCookies = payload.dismiss_cookies;
    }
    this.emitChange();
  },

  dismissCookiesStart() {
    this.dismissCookies = true;
    this.emitChange();
  },

  requestStart() {
    this.currentRequestStatus = RequestStates.Loading;
    this.currentError = null;
    this.emitChange();
  },

  requestSuccess() {
    this.currentRequestStatus = RequestStates.Done;
    this.currentError = null;
    this.emitChange();
  },

  requestFailure(error) {
    if(!error) {
      this.currentRequestStatus = RequestStates.Done;
      return this.emitChange();
    }
    this.currentRequestStatus = RequestStates.Error;
    this.currentError = error;
    this.logError(error);
    this.emitChange();
  },

  authSuccess(data) {
    this.currentCustomer = data.customer;
    this.requestSuccess();
  },

  fetchSuccess(customer) {
    this.currentRequestStatus = RequestStates.Done;
    this.currentError = null;
    this.currentCustomer = customer;
    this.emitChange();
  },

  updateSuccess(customer) {
    this.currentRequestStatus = RequestStates.Done;
    this.currentError = null;
    this.currentCustomer = customer;
    this.emitChange();
  },

  updateFailure(error) {
    this.currentRequestStatus = RequestStates.Error;
    this.currentError = error;
    this.logError(error);
    this.emitChange();
  },

  getCookiesDismissed() {
    return this.dismissCookies;
  },

  getCurrentCustomer() {
    return this.currentCustomer;
  },

  getCurrentError() {
    return this.currentError;
  },

  getCurrentRequestStatus() {
    return this.currentRequestStatus;
  },

  dehydrate() {
    return {
      currentCustomer: this.currentCustomer ? this.currentCustomer.toJS() : null,
      dismissCookies: this.dismissCookies
    };
  },

  rehydrate(state) {
    if (state.currentCustomer != null) {
      this.currentCustomer = new Customer(state.currentCustomer);
    }
    if (state.dismissCookies) {
      this.dismissCookies = state.dismissCookies;
    }
  }
});

export default CustomerStore;



// WEBPACK FOOTER //
// banquet/stores/CustomerStore.js